import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path fill="#00D8D8" d="M10.17 25.15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M32.57 16.59a1.5 1.5 0 0 1 0 2.121l-10 10a1.5 1.5 0 0 1-2.12-2.121l10-10a1.5 1.5 0 0 1 2.12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M20.45 16.59a1.5 1.5 0 0 1 2.12 0l10 10a1.5 1.5 0 0 1-2.12 2.121l-10-10a1.5 1.5 0 0 1 0-2.121M93.24 83.69a1.5 1.5 0 0 1 1.5 1.5v14.13a1.5 1.5 0 0 1-3 0V85.19a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M84.67 92.25a1.5 1.5 0 0 1 1.5-1.5h14.14a1.5 1.5 0 0 1 0 3H86.17a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M108.57 86.46a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M58 91c18.229 0 33-14.78 33-33S76.22 25 58 25 25 39.78 25 58s14.78 33 33 33"
    />
    <mask
      id="enrichedIcon-QuickPaymentsInverted_svg__a"
      width={66}
      height={66}
      x={25}
      y={25}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M58 91c18.229 0 33-14.78 33-33S76.22 25 58 25 25 39.78 25 58s14.78 33 33 33"
      />
    </mask>
    <g
      fill="#B0FFFF"
      fillRule="evenodd"
      clipRule="evenodd"
      mask="url(#enrichedIcon-QuickPaymentsInverted_svg__a)"
    >
      <path d="M92.548 23.04a3.3 3.3 0 0 1 0 4.667l-60.08 60.08a3.3 3.3 0 0 1-4.667-4.667l60.08-60.08a3.3 3.3 0 0 1 4.667 0M97.012 33.376a3.3 3.3 0 0 1 0 4.667l-60.09 60.08a3.3 3.3 0 1 1-4.667-4.667l60.09-60.08a3.3 3.3 0 0 1 4.667 0" />
    </g>
    <path
      fill="#00D8D8"
      d="M58 84c14.36 0 26-11.64 26-26S72.36 32 58 32 32 43.64 32 58s11.64 26 26 26"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M59.82 43.94a2.25 2.25 0 1 0-4.5 0v1.431c-1.495.301-2.87.9-4.001 1.748-1.683 1.262-2.93 3.176-2.93 5.48s1.246 4.22 2.928 5.484c1.68 1.263 3.898 1.977 6.253 1.977 1.475 0 2.722.451 3.55 1.073.828.62 1.13 1.308 1.13 1.877 0 .566-.302 1.253-1.133 1.876-.795.596-1.972 1.035-3.36 1.071a2.3 2.3 0 0 0-.459.009 5.23 5.23 0 0 1-4.19-2.061 2.25 2.25 0 1 0-3.577 2.73 9.74 9.74 0 0 0 5.79 3.634v1.39a2.25 2.25 0 1 0 4.5 0v-1.423c1.493-.302 2.866-.903 3.996-1.75 1.68-1.26 2.933-3.173 2.933-5.476 0-2.301-1.248-4.215-2.928-5.476-1.68-1.26-3.897-1.974-6.252-1.974-1.475 0-2.722-.452-3.55-1.074-.826-.621-1.13-1.31-1.13-1.886s.303-1.262 1.128-1.88c.827-.62 2.075-1.07 3.552-1.07h.046l.046-.002a5.2 5.2 0 0 1 4.355 2.05 2.25 2.25 0 1 0 3.586-2.717 9.7 9.7 0 0 0-5.783-3.641z"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M5.75 44A2.25 2.25 0 0 1 8 41.75h14a2.25 2.25 0 0 1 0 4.5H8A2.25 2.25 0 0 1 5.75 44M5.75 72A2.25 2.25 0 0 1 8 69.75h14a2.25 2.25 0 0 1 0 4.5H8A2.25 2.25 0 0 1 5.75 72M.75 58A2.25 2.25 0 0 1 3 55.75h14a2.25 2.25 0 0 1 0 4.5H3A2.25 2.25 0 0 1 .75 58M34 94a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconQuickPaymentsInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconQuickPaymentsInverted);
export default Memo;
